/* Batana: selector de packs y barra de pedido fija. */
(function () {
  function montar(raiz) {
    (raiz || document).querySelectorAll('[data-ig-packs]').forEach(function (bloque) {
      if (bloque.hasAttribute('data-ig-listo')) return;
      bloque.setAttribute('data-ig-listo', '');
      var radios = bloque.querySelectorAll('.ig-pack input');
      var cantidad = bloque.querySelector('[data-ig-pack-cantidad]');
      var total = bloque.querySelector('[data-ig-pack-total]');
      var total2 = bloque.querySelector('[data-ig-pack-total-2]');
      var nombreBarra = bloque.querySelector('[data-ig-pack-nombre]');
      var fotos = bloque.querySelectorAll('.ig-packs__foto img');
      var boton = bloque.querySelector('.ig-packs__boton');
      var barra = bloque.querySelector('[data-ig-barra]');

      function elegir(radio) {
        if (cantidad) cantidad.value = radio.value;
        var texto = radio.getAttribute('data-total');
        if (total) total.textContent = texto;
        if (total2) total2.textContent = texto;
        if (nombreBarra) {
          var base = nombreBarra.getAttribute('data-base') || '';
          var pack = radio.getAttribute('data-nombre') || '';
          nombreBarra.textContent = pack ? base + ' · ' + pack : base;
        }
        /* Pequeño rebote del precio para que se note el cambio. */
        if (total && total.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          total.animate([{ transform: 'scale(1.18)' }, { transform: 'scale(1)' }], { duration: 380, easing: 'cubic-bezier(.22,1,.36,1)' });
        }
        var n = parseInt(radio.getAttribute('data-indice'), 10) || 0;
        if (fotos.length > n) {
          fotos.forEach(function (f, i) { f.classList.toggle('ig-activa', i === n); });
        }
      }
      radios.forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked) elegir(r); });
        if (r.checked) elegir(r);
      });

      /* Con EasySell activo, el botón y la barra abren su formulario contra entrega
         (lee la cantidad del pack elegido); si la app no está, el formulario sigue su curso normal. */
      var formulario = boton && boton.form;
      if (formulario) {
        formulario.addEventListener('submit', function (ev) {
          var easysell = formulario.querySelector('#es-popup-button');
          if (!easysell) return;
          ev.preventDefault();
          easysell.click();
        });
      }

      /* La barra aparece cuando el botón de compra ya no está en pantalla (antes o después). */
      if (barra && boton && 'IntersectionObserver' in window) {
        var visto = false;
        new IntersectionObserver(function (e) {
          var dentro = e[0].isIntersecting;
          barra.classList.toggle('ig-visible', !dentro && window.scrollY > 500);
          visto = dentro;
        }).observe(boton);
        window.addEventListener('scroll', function () {
          if (!visto) barra.classList.toggle('ig-visible', window.scrollY > 500);
        }, { passive: true });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { montar(document); });
  else montar(document);
  document.addEventListener('shopify:section:load', function (ev) { montar(ev.target); });
})();
